import React from 'react';

interface HighlightedHeadingProps {
  children: React.ReactNode;
  highlightedText: string;
  className?: string;
  level?: 'h1' | 'h2' | 'h3';
  align?: 'left' | 'center' | 'right';
}

export const HighlightedHeading: React.FC<HighlightedHeadingProps> = ({
  children,
  highlightedText,
  className = '',
  level = 'h2',
  align = 'center'
}) => {
  const Tag = level as keyof JSX.IntrinsicElements;
  
  const textAlign = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  }[align];

  const renderText = () => {
    return children;
  };

  return (
    <Tag 
      className={`font-playfair font-normal text-[#0a2540] leading-tight ${textAlign} ${className}`}
    >
      {renderText()}
    </Tag>
  );
};
